fragment InboundSmsRulesFragment on InboundSmsRules {
    assignment {
        strategy
        assignedUser {
            id
            name
        }
    }
    leadCreation {
        enabled
        stageset {
            id
            name
        }
        tags {
            id
            name
        }
    }
    redirectPhoneNumber {
        numberFormatted
    }
}
